import axiosInstance from "./axiosInstance";
import APIEndpoint from "./endpoint";

export const getListVisitYear = async (searchValue) => {
  const api = `${APIEndpoint.GET_LIST_VISIT_YEAR}`;

  const res = await axiosInstance.get(api);
  return res;
};

export const getListVisit = async (searchValue) => {
  const api = `${APIEndpoint.GET_LIST_VISIT}`;

  const res = await axiosInstance.get(api);
  return res;
};

export const getListVisitById = async (id) => {
  const api = `${APIEndpoint.GET_LIST_VISIT_ฺBY_ID}` + `/${id}`;

  const res = await axiosInstance.get(api);
  return res;
};

export const searchVisitCustomers = (searchValues, pageValues) => {
  const api = APIEndpoint.SEARCH_VISIT_API;
  const payload = {
    requestObject: {
      yearOfBudget: searchValues.yearOfBudget || "",
      lineOfWork: searchValues.lineOfWork || "",
      estateId: searchValues.estateId || "",
    },
    pageValue: {
      page: pageValues.page,
      pageSize: pageValues.pageSize,
      sortBy: pageValues.sortBy,
      sortDirection: pageValues.sortDirection,
    },
  };

  const res = axiosInstance.post(api, payload);
  return res;
};

export const createVisit = async (request) => {
  const api = APIEndpoint.CREATE_VISIT_API;
  const res = await axiosInstance.post(api, JSON.stringify(request));
  return res;
};

export const updateVisit = async (id, request) => {
  const api = APIEndpoint.UPDATE_VISIT_API + `/${id}`;
  const res = await axiosInstance.put(api, JSON.stringify(request));
  return res;
};

export const deleteVisit = (id) => {
  const api = APIEndpoint.DELETE_VISIT_API + `/${id}`;
  const res = axiosInstance.delete(api);
  return res;
};
